import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react';
import { Radar } from '@ant-design/plots';

import userReport from "../../../images/aiReport/user-report.png";
import fh from "../../../images/aiReport/fh.png";

import CardProgress from "../common/cardProgress";

import { competencyList, titleList, unparam } from 'utils/common';

const ResultApp = (props) => {
    const queryString = unparam(window.location.search);
    let langEn = queryString.lang === 'en_us';
    let title = langEn ? titleList['社会平均分'] : '社会平均分';
    let title1 = langEn ? titleList['候选人得分'] : '候选人得分';
    let AnalysisResultsTitle = langEn ? titleList['分析结果'] : '分析结果';
    const detail = props.data || {};
    const {colorRecognitionResult = null, gestureDetectionResult = null, commonSenseResult = null} = detail;
    // detail.profile = {
    //     evaluate: '发色：黑色。相貌端正。',
    //     status: 0,
    //     desc: '佳'
    // }
    // detail.eval1 = ['具有较好的人际理解力，能倾听井合理推断对方未充分表达的想法和担忧，并给出比较怡当的反应。'];
    // detail.eval2 = '各能力素质表现均中等，没有明显的优势或劣势素质。';
    // detail.eval3 = [
    //     '具有一定的合作意识，能和团队成员友好相处和共同解决问题，但在个人利益受到影响时可能会优先。',
    //     '具备强烈的创新精神，兴趣广泛，对新事物接受能力强，能多角度思考问题，敢于挑战权威，提出井实践自己的新观念、新思路。',
    //     '具备基本的适应能力，在熱悉的环境中会更自如，但在新环境中融入较慢，有时会不太性得妥协和让步。'
    // ];
    const radarDataList = detail.radarDataList || [];
    const userInfo = props.userInfo || {};
    const hasAiAbility = props.hasAiAbility || false;

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    },[detail])

    useEffect(() => {
        if(radarDataList.length){
            printRing( 180 , 20 , 130, radarDataList, (value)=>{
                let list = [];
                value.forEach(val => {
                    const abilityItem = langEn ? competencyList[val.abilityItem] : val.abilityItem;
                    // 社会平均分
                    list.push({
                        item: abilityItem,
                        score: val.standardScore || 0,
                        user: title,
                        x: val.x,
                        y: val.y,
                    })
                    // 候选人得分
                    list.push({
                        item: abilityItem,
                        score: val.currentScore || 0,
                        user: title1,
                        x: val.x,
                        y: val.y,
                    })
                })
                setData(list);
            });
        }
    }, [radarDataList]);

    function printRing( bcr , mcr , scr, list, callback ){
        // bcr 大圆半径，mcr 大圆和小圆之间那个圆的半径（这个圆的直径不能超过大圆半径和小圆半径的差值），scr 小圆半径
        let len = list.length;
        let a =  Math.PI / 180;
        let r = ( bcr - scr ) / 2 + scr; //环形的半径=（大圆半径 - 小圆半径）/ 2 + 小圆半径；
        let angle = 360 / len; //根据span的数量来决定弧度大小
        for( let i = 0 ; i < len ; i++){
            let x = bcr + Math.sin( a * angle * (len - i) ) * r;
            let y = bcr + Math.cos( a * angle * (len - i) ) * r;
            list[i].x = x - mcr;
            list[i].y = y - mcr;
        }
        callback(list)
    }
    
    const config = {
        data,
        // width: 400,
        height: 260,
        xField: 'item',
        yField: 'score',
        seriesField: 'user',
        legend: false,
        showContent: false,
        autoFit: true,
        appendPadding: [10, 10, 10, 10],
        radius: 0.75,
        meta: {
            score: {
                alias: '分数',
                min: 0,
                max: 10,
            },
        },
        colorField: 'user',
        color: ({ user }) => {
            if(user == '社会平均分'){
                return '#FDAE21';
            }
            if(user == '候选人得分'){
                return '#5473FF';
            }
        },
        lineStyle: {
            lineWidth: 0,
        },
        smooth: true,
        xAxis: {
            line: null,
            tickLine: {
                style: {
                    stroke: '#E7EDF8',
                }
            },
            grid: {
                line: {
                    style: {
                        lineDash: null,
                        stroke: '#E7EDF8',
                    },
                },
            },
            label: {
                autoEllipsis: true,
                style: {
                    fill: '#272D4E',
                    fontSize: 14,
                    fontWeight: 600,
                    fontFamily: 'PingFang SC',
                },
                // formatter: (text, item, index) => {
                //     if (typeof text === 'string' && text.length > 15) {
                //         return `${text.slice(0, 15)}...`; 
                //     }
                //     return text;
                // },
            },
        },
        yAxis: {
            // label: false,
            line: {
                style: {
                    lineDash: [0,0],
                    stroke: 'transparent',
                },
            },
            tickLine: null,
            grid: {
                line: {
                    style: {
                        lineWidth: 2,
                        lineDash: [2,2],
                        stroke: '#E7EDF8',
                    },
                }
            },
        },
        // 开启辅助点
        point: {
            size: 0,
        },
        area: {
            smooth: true,
            color: ['#FDAE21','#5473FF'],
            style: (x, y, series) => {
                // console.log(x, y, series)
                return {
                    fillOpacity: 0.7,
                }
            },
        },
        grid: {
            closed: false,
            alignTick: false,
        },
    };

    const filterClass = (level) => {
        switch (level) {
            case '好':
                return 'c52C41B' ;
            case '一般':
                return 'fdae21';
            case '不标准':
                return 'ff4d4f';
            default:
                return '';
        }
    };

    const renderEvaluate = useMemo(() => {
        if(detail.eval1 || detail.eval2 || detail.eval3){
            return (
                <div className="result-evaluate-cont" style={{marginTop: '-6px'}}>
                    <div className="result-evaluate-advantage-title">评估结果表明，该候选人：
                        {(detail.eval1 || detail.eval3) ? null : <span>{detail.eval2}</span>}
                    </div>
                    {detail.eval1 && detail.eval1.length > 0 ? <Fragment>
                        <div className="result-evaluate-advantage-label">优势素质</div>
                        {detail.eval1.map((item,key) =>
                            <div className="result-evaluate-advantage-text">{`${detail.eval1.length > 1 ? (key + 1) + '.' : ''}${item}`}</div>
                        )}
                    </Fragment> : null}
                    {detail.eval3 && detail.eval3.length > 0 ? <Fragment>
                        <div className="result-evaluate-advantage-label inferiority">劣势素质</div>
                        {detail.eval3.map((item,key) =>
                            <div className="result-evaluate-advantage-text">{`${detail.eval3.length > 1 ? (key + 1) + '.' : ''}${item}`}</div>
                        )}
                    </Fragment> : null}
                </div>
            );
        }
        return (
            <div className="result-evaluate-cont">
                {detail.totalEvaluate || detail.eval2 || ''}
            </div>
        );
    }, [detail]);

    if(detail.chineseLevel || detail.cheatingRisk || radarDataList.length > 0 || detail.profile || (commonSenseResult || colorRecognitionResult || gestureDetectionResult)){
        return (
            <div className="result-wrap">
                <div className="readingTitleWrap">
                    <div className="readingTitleLeft">
                        <div className="readingTitleLeftIcon">
                            <span></span>
                            <span></span>
                        </div>
                        <span>{AnalysisResultsTitle}</span>
                        {hasAiAbility && <Fragment>
                            {radarDataList.length > 2 ?
                                <Fragment>
                                    <div className="readingTitleTab active">
                                        <i></i>
                                        <p>{title}</p>
                                    </div>
                                    <div className="readingTitleTab">
                                        <i></i>
                                        <p>{title1}</p>
                                    </div>
                                </Fragment>
                                :   <Fragment>
                                    {radarDataList.map((value, k) => {
                                        return <div key={`k_${k}`} className="readingTitleTab1">
                                            <span className="readingTitleTab1-name">{value.abilityItem || ''}</span>
                                            <CardProgress active={value.currentScore}/>
                                        </div>
                                    })}
                                </Fragment>
                            }
                        </Fragment>}
                    </div>
                    <div className="readingTitleRight">

                    </div>
                </div>
                {/*内容部分*/}
                <div className="result-padding">

                    {radarDataList.length > 2 && hasAiAbility ? <div className="result-chart-wrap">
                        <div className="facePicPath">
                            {detail.facePicPath ? (
                                <img src={detail.facePicPath || userInfo.facePicPath} onError={(e) => e.target.src = userReport}/>
                            ) : !isLoading ? <img src={userReport}/> : null}
                        </div>
                        <div className="result-chart">
                            <Radar {...config} />
                        </div>
                    </div> : null}

                    {radarDataList.length > 2 && hasAiAbility && <div className="result-evaluate">
                        <img src={fh} className="result-evaluate-d"/>
                        <div className="result-evaluate-tit">面试评价</div>
                        {renderEvaluate}
                    </div>}
                    {/*类目小于等于2 显示*/}
                    {radarDataList.length <= 2 && hasAiAbility ? (
                        <div className="result-chart-wrap1">
                            <div className="facePicPath">
                                {detail.facePicPath ? (
                                    <img src={detail.facePicPath || userInfo.facePicPath} onError={(e) => e.target.src = userReport}/>
                                ) : !isLoading ? <img src={userReport}/> : null}
                            </div>
                            <div className="result-evaluate">
                                <img src={fh} className="result-evaluate-d"/>
                                <div className="result-evaluate-tit">面试评价</div>
                                {renderEvaluate}
                            </div>
                        </div>
                    ) : null}
                    
                    {/* {detail.chineseLevel && <div className="result-item">
                        <p>
                            <span>普通话水平：</span>
                            <span className={filterClass(detail.chineseLevel)}>{detail.chineseLevel}</span>
                        </p>
                        <div>{detail.chineseLevelEval}</div>
                    </div>}
                    {detail.enLevel && <div className="result-item">
                        <p>
                            <span>英语水平：</span>
                            <span className={filterClass(detail.enLevel)}>{detail.enLevel}</span>
                        </p>
                        <div>{detail.enLevelDesc}</div>
                    </div>} */}
                    {/* 新数据 语言水平 langLevels*/}
                    {
                        detail.langLevels && detail.langLevels.length > 0 ? (
                            <Fragment>
                                {detail.langLevels.map(item => (
                                    <div className="result-item">
                                        <p>
                                            <span>{item.title || ''}：</span>
                                            <span className={filterClass(item.desc)}>{item.desc}</span>
                                        </p>
                                        <div>{item.evaluate}</div>
                                    </div>
                                ))}
                            </Fragment>
                        ): null
                    }

                    {/* 形象气质 profile*/}
                    {detail.profile && <div className="result-item">
                        <p>
                            <span>形象气质：</span>
                            <span className={`${detail.profile.status == 0 ? 'c52C41B' : 'ff4d4f'}`}>{`${detail.profile.desc || ''}`}</span>
                        </p>
                        <div>{`${detail.profile.evaluate || ''}`}</div>
                    </div>}
                    {/* 其他 */}
                    {(commonSenseResult || colorRecognitionResult || gestureDetectionResult) && <div className="result-item">
                        <p>
                            <span>其他 </span>
                        </p>
                        <div className="result-item-other">
                            {commonSenseResult && (
                                <div>常识检测：<span>{commonSenseResult.score || 0}分/{commonSenseResult.totalScore || 0}分</span>{colorRecognitionResult || gestureDetectionResult ? '，' : '。'}</div>
                            )}
                            {colorRecognitionResult && (
                                <div>辨色检测：<span className={`${colorRecognitionResult.status == 0 ? 'c52C41B' : 'ff4d4f'}`}>{`${colorRecognitionResult.desc || ''}`}</span>{gestureDetectionResult ? '，' : '。'}</div>
                            )}
                            {gestureDetectionResult && (
                                <div>手部综合检测：<span className={`${gestureDetectionResult.status == 0 ? 'c52C41B' : 'ff4d4f'}`}>{`${gestureDetectionResult.desc || ''}`}</span>。</div>
                            )}
                        </div>
                    </div>}
                    {<div className="result-item">
                        <p>
                            <span>作弊风险：</span>
                            <span className={detail.cheatingRisk ? "ff4d4f" : "c52C41B"}>{detail.cheatingRisk ? '有' : '无'}</span>
                        </p>
                        {detail.cheatingRisk && <div>面试过程中
                            <span>{detail.notSelfExam ? '多' : 0}次</span>出现非本人面试；
                            <span>{detail.screenShotNum || 0}次</span>截屏；<span>{detail.examBreakNum || 0}次</span>面试中断</div>}
                    </div>}
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default ResultApp;
